import { createAction } from '@reduxjs/toolkit';

export const DELETE_VOICEMAIL_ACTION_TYPE = 'saga/deleteVoicemail';
export const deleteVoicemailAction = createAction(DELETE_VOICEMAIL_ACTION_TYPE);
